import { render, staticRenderFns } from "./drInfoCell.vue?vue&type=template&id=0d5036b8&scoped=true"
import script from "./drInfoCell.vue?vue&type=script&lang=js"
export * from "./drInfoCell.vue?vue&type=script&lang=js"
import style0 from "./drInfoCell.vue?vue&type=style&index=0&id=0d5036b8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5036b8",
  null
  
)

export default component.exports